import { FeatureList } from "./components/featureList/featuresList";
import { Title } from "./components/title/title";
import { Base } from "./storeFeatures.base";

export const StoreFeatures = Object.assign(Base, {
    FeatureList: FeatureList,
    Title: Title
});
